import { render, staticRenderFns } from "./SalesPo.vue?vue&type=template&id=1b72ed3c&scoped=true&"
import script from "./SalesPo.vue?vue&type=script&lang=js&"
export * from "./SalesPo.vue?vue&type=script&lang=js&"
import style0 from "./SalesPo.vue?vue&type=style&index=0&id=1b72ed3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72ed3c",
  null
  
)

export default component.exports